import styled from 'styled-components';

export const StyledActionsDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  button:last-child {
    margin-left: ${({ theme }) => theme.spacing.space_3};
  }
`;
